// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__NY7OA","root":"tabs_root__4ykNx","indicator":"tabs_indicator__j3Xip","active":"tabs_active__I1_G2"};